import classNames from "classnames";

import { TeamID } from "../../../types";
import { HeaderBreadCrumbs } from "../../ProjectPageHeader/ProjectPageHeader";

import style from "./FloatingBreadcrumbs.module.css";

interface FloatingBreadcrumbsProps {
  teamId: TeamID;
  spaceName: string;
  isClosed?: boolean;
}
export const FloatingBreadcrumbs = ({ teamId, spaceName, isClosed }: FloatingBreadcrumbsProps) => {
  return (
    <div className={classNames(style.floatingBreadcrumbs, { [style.closed]: isClosed })}>
      <HeaderBreadCrumbs teamID={teamId} spaceName={spaceName} />
    </div>
  );
};
